import { defineComponent as _defineComponent } from 'vue'
import { IEventOrganizationChip } from '@/enitites/event'
import { useImage } from '@/shared/composables/image'


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationLabel',
  props: {
    chip: null
  },
  setup(__props: any) {

const { getImageById } = useImage()


return { __sfc: true,getImageById }
}

})